import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import onWebviewClose from "../components/Button";
import Shield from "../components/Shield";
import InternalError from "../components/InternalError";
import LoadingBar from "../components/LoadingBar";
import { config } from "../config/config";
import withStyles from "@mui/styles/withStyles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import "../css/notice.css";
import uploadLog from "../modules/uploadLog";
// import renderHtml from "react-render-html";
import { renderHtml } from "../components/RenderHtml";
import Moment from "react-moment";
import axios from "axios";
import {
  Container,
  ContentsWrapper,
  ImageWrapper,
  TextWrapper,
  Title,
  Description,
  Date,
  CloseBtn,
} from "../components/Detail";

const styles = (theme) => ({
  offset: theme.mixins.toolbar,
});

const NoticeArticle = (props) => {
  const [notices, setNotices] = useState();
  const [errMsg, setErrMsg] = useState();
  const UrlQueryStrings = window.location.search;

  const _renderNotice = () => {
    try {
      if (notices.files && notices.files[0] && notices.files[0].src) {
        return (
          <>
            <TextWrapper
              className={
                config.SPACE_FREE.indexOf(notices.language_code) !== -1
                  ? "isBreakAll"
                  : ""
              }
              style={{ width: "100vw" }}
              dir={
                config.ARAB.indexOf(notices.language_code) !== -1 ? "rtl" : ""
              }
            >
              <Title>
                {notices.subtitle !== "" ? notices.subtitle : notices.title}
              </Title>
              <Date>
                <Moment format="MMM DD, YYYY">
                  {notices.createdAt ? notices.createdAt : notices.publishedAt}
                </Moment>
              </Date>
              <ImageWrapper>
                <img
                  style={{ width: "100%" }}
                  src={notices.files[0].src}
                  alt={notices.files[0].title}
                />
              </ImageWrapper>
              <Description>
                <div style={{ marginLeft: 0 }}>
                  {notices !== undefined ? renderHtml(notices.description) : ""}
                </div>
              </Description>
            </TextWrapper>
          </>
        );
      } else {
        return (
          <>
            <TextWrapper
              className={
                config.SPACE_FREE.indexOf(notices.language_code) !== -1
                  ? "isBreakAll"
                  : ""
              }
              style={{ width: "100vw" }}
              dir={
                config.ARAB.indexOf(notices.language_code) !== -1 ? "rtl" : ""
              }
            >
              <Title>
                {notices.subtitle !== "" ? notices.subtitle : notices.title}
              </Title>
              <Date>
                <Moment format="MMM DD, YYYY">
                  {notices.createdAt ? notices.createdAt : notices.publishedAt}
                </Moment>
              </Date>
              <Description>
                <div style={{ marginLeft: 0 }}>
                  {notices !== undefined ? renderHtml(notices.description) : ""}
                </div>
              </Description>
            </TextWrapper>
          </>
        );
      }
    } catch (err) {
      setErrMsg(err.message);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const apiCall = async () => {
    try {
      const noticeData = await axios.get(
        process.env.REACT_APP_API_HOST +
          "notices/" +
          props.match.params.id +
          UrlQueryStrings,
      );

      setNotices(noticeData.data);
    } catch (err) {
      setErrMsg(err.message);
    }
  };

  useEffect(() => {
    apiCall();
  }, []);

  if (errMsg) {
    uploadLog(window.location.href, "ERROR", errMsg);
    return (
      <Container>
        <CloseBtn onClick={onWebviewClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              marginRight: "1.1875rem",
            }}
            width="28"
            height="28"
            viewBox="0 0 28 28"
          >
            <g fill="none" fillRule="evenodd">
              <g fillRule="nonzero">
                <g>
                  <path
                    d="M0 0H28V28H0z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                  <path
                    fill="var(--text-color)"
                    d="M21.467 6.535c.466.467.466 1.05.116 1.517l-.116.117-5.717 5.833 5.833 5.717c.467.466.467 1.166 0 1.633-.466.467-1.05.467-1.516.117l-.234-.117L14 15.635 8.167 21.47c-.467.466-1.167.466-1.634 0-.466-.467-.466-1.05-.116-1.517l.116-.117 5.834-5.833-5.834-5.717c-.466-.466-.466-1.166 0-1.633.467-.467 1.05-.467 1.517-.117l.117.117L14 12.37l5.717-5.717c.583-.583 1.283-.583 1.75-.117z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </CloseBtn>
        <InternalError />
      </Container>
    );
  }
  return (
    <Container>
      <button
        id="backkeyTrigger"
        style={{ display: "none" }}
        onClick={onWebviewClose}
      ></button>
      <Shield>
        <Helmet>
          <title>KineMaster Notice</title>
        </Helmet>
        <AppBar
          style={{
            backgroundColor: "var(--bg-color)",
            position: "fixed",
            minHeight: "2.75rem",
            boxShadow: "none",
          }}
        >
          <Toolbar
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              padding: "0px 1.1875rem",
            }}
          >
            <Link to={`/${UrlQueryStrings}`}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="close"
                style={{ padding: "0px", marginLeft: "0px" }}
              >
                <svg width="1.625rem" height="1.625rem" viewBox="0 0 26 26">
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="var(--text-color_sub1)"
                    strokeLinecap="round"
                    strokeWidth="2"
                  >
                    <path d="M7.757 13.243l8.486 8.486M16.242 4.757l-8.485 8.486" />
                  </g>
                </svg>
              </IconButton>
            </Link>
          </Toolbar>
        </AppBar>
        <div className="header-size-element" />
        <ContentsWrapper>
          {notices ? _renderNotice() : <LoadingBar />}
        </ContentsWrapper>
      </Shield>
    </Container>
  );
};

export default withStyles(styles)(NoticeArticle);
